import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-logo',
  styleUrls: ['./logo.component.scss'],
  templateUrl: './logo.component.html'
})
export class LogoComponent implements OnInit {

  // Constants
  private logoColors = {
    PRIMARY: 'logo-primary',
    SECONDARY: 'logo-secondary',
    LIGHT: 'logo-light',
    DARK: 'logo-dark',
    GREY: 'logo-grey'
  }

  private logoSizes = {
    SMALL: 'logo-sm',
    LARGE: 'logo-lg'
  }

  // UI Variables
  public class: string;
  private color: string = '';
  private size: string = '';

  private logo: HTMLElement;

  constructor(private el: ElementRef) {
    this.logo = this.el.nativeElement as HTMLElement
  }

  ngOnInit(): void {
    this.setLogoSize();
    this.setLogoColor();
    this.setLogoClass();
  }

  private setLogoColor(): void {
    if (this.logo.hasAttribute('primary')) {
      this.color = this.logoColors.PRIMARY;
    }
    else if (this.logo.hasAttribute('secondary') || this.logo.hasAttribute('main')) {
      this.color = this.logoColors.SECONDARY;
    }
    else if (this.logo.hasAttribute('dark')) {
      this.color = this.logoColors.DARK;
    }
    else if (this.logo.hasAttribute('light')) {
      this.color = this.logoColors.LIGHT;
    }
    else if (this.logo.hasAttribute('grey')) {
      this.color = this.logoColors.GREY;
    }
  }

  private setLogoSize(): void {
    if (this.logo.hasAttribute('sm')) {
      this.size = this.logoSizes.SMALL;
    }
    else if (this.logo.hasAttribute('lg')) {
      this.size = this.logoSizes.LARGE;
    }
  }

  private setLogoClass(): void {
    this.class = [this.size, this.color].join(' ');
  }

}
